import { h } from 'preact';
import { CheckboxEntry } from '../entries/CheckboxEntry';

export class SubProcessPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:SubProcess' || elementType === 'epx:Transaction';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const entries = [];

    // triggeredByEvent checkbox (only for SubProcess, not Transaction)
    if (element.type === 'epx:SubProcess') {
      entries.push({
        id: 'triggeredByEvent',
        component: () => (
          <CheckboxEntry
            id="epx-triggered-by-event"
            label={i18n.triggeredByEvent || 'Triggered by Event'}
            value={!!props.triggeredByEvent}
            onChange={(val) => {
              lf.setProperties(id, { triggeredByEvent: val });
              lf.emit('node:properties-change', { id, properties: { triggeredByEvent: val } });
            }}
          />
        ),
      });
    }

    return [
      {
        id: 'subProcess',
        label: i18n.subProcess || 'Sub-Process',
        entries,
      },
    ];
  }
}
